import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import env from "app/utils/env";

const fetchSearchHotels = ({ q, partnerCode, limit, path }) =>
	axios
		.get(`${env("CACHED_API_URL")}${path}`, { params: { q, limit, partnerCode } })
		.then(res => res.data);

export const useSearchHotels = ({ q = "", partnerCode, limit = 20, path = "/search-hotels" }) =>
	useQuery({
		queryKey: ["searchHotels", q, partnerCode, limit, path],
		queryFn: () => fetchSearchHotels({ q, partnerCode, limit, path }),
		enabled: Boolean(partnerCode) && q.length > 0,
		staleTime: 1000 * 60 * 5,
	});
